var expandShareBox;

$(function () {

    // funkcija koja otvara/zatvara share box
    expandShareBox = function() {

        var $expandBtn = $('.js_shareLabel'),
            $expandCheckbox;

        if ( $expandBtn.length ) {

            $expandBtn.each(function(index, val) {

                var $this = $(this);

                if ( ! $this.hasClass('js_shareINIT') ) {

                    $this.addClass('js_shareINIT');

                    $this.on('click', function() {

                        $expandCheckbox = $this.parents('.js_shareWrap').find('.js_shareCheckbox');

                        if( $expandCheckbox.is(':checked') ) {

                            $expandCheckbox.prop('checked', false);

                        } else {

                            $expandCheckbox.prop('checked', true);

                        }

                    });

                }

            });
        }

    };

    expandShareBox();

});